import {createEvent} from "effector";

export const sendRequestDemoEv = createEvent()

export const resetShowPopupEv = createEvent()

export const toggleShowMenuEv = createEvent()

export const togglePostPopupEv = createEvent()
